$(document).ready(function(){
  $('.machine-sel').hover(function(){
    $('.submenu-one').addClass('active');
  });
  $('.submenu').mouseover(function () {   
    $('.submenu-content').removeClass('active').eq($(this).index('.submenu')).addClass('active');
  });
  $('.bucket-attach').mouseover(function () {
    $('.bucket-content').removeClass('active').eq($(this).index('.bucket-attach')).addClass('active');
  }); 
  $('.sel-qh').hover(function(){
    $('.submenu-one-qh').addClass('active');
  });
  $('.submenu-qh').mouseover(function () {
    $('.submenu-content-qh').removeClass('active').eq($(this).index('.submenu-qh')).addClass('active');
  });
  $('.terms').mouseover(function(){
    $('.terms_more').removeClass('active').eq($(this).index('.terms')).addClass('active');
  });
});